import { LAUNCH_EXPORTS, LaunchesTab } from './launches'

// The tabs of the LMS insights pages, in order. Adding a tab is one entry:
//   id, label  the tab's name and its address's last part
//   to         its address (the layout redirects the section to the first)
//   Component  the tab, drawn with { filters, refreshKey } (launches.js)
//   exports    [{ report, label }] the downloads its reports offer
export const LMS_INSIGHT_BASE = '/org/analytic/lms'

export const LMS_INSIGHT_TABS = [
  { id: 'launches', label: 'Launches', to: `${LMS_INSIGHT_BASE}/launches`, Component: LaunchesTab, exports: LAUNCH_EXPORTS }
]
